import { useEffect } from "react"
import UploadDataReportForm from "./UploadDataReportForm"



const UploadDataReport = ({ open }) => {
    useEffect(() => {
        document.title = 'Upload Data Report'
    }, [])
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            < UploadDataReportForm />
        </main>
    )
}
export default UploadDataReport